export const  init = () => {
    //Hamburger menu
    const hamburger = document.querySelector('.hamburger-menu');
    hamburger.addEventListener('click', function () {
        document.querySelector('.header__items').classList.toggle('expand');
        document.querySelector('.header').classList.toggle('bg-white');
        this.classList.toggle('active');
    });
};